import { render, staticRenderFns } from "./TimeStudyConnection.vue?vue&type=template&id=99b5bd1a&scoped=true"
import script from "./TimeStudyConnection.vue?vue&type=script&lang=js"
export * from "./TimeStudyConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b5bd1a",
  null
  
)

export default component.exports